import { useNavigate } from "react-router-dom";
import LeftIcon from "../../Assets/Icons/LeftIcon";
import "./backbtn.css";
import { useEffect } from "react";

const BackBtn = ({ navigateTo = -1, state = {} }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(navigateTo);
  };

  useEffect(() => {
    console.log(window.history.length);
  }, []);

  return (
    <div className="back-btn-global">
      <button className="btn btn-primary" onClick={handleBack}>
        <LeftIcon />
      </button>
    </div>
  );
};

export default BackBtn;
